import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8d8179fa")
const _hoisted_1 = { class: "dvIcePoint" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "设置", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"80%","font-size":"22px","color":"#78543a"} }, "缓存文件目录", -1)
const _hoisted_4 = { class: "folderSetting" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"80%","font-size":"22px"} }, " 音画同步延迟设置（-200~500毫秒） ", -1)
const _hoisted_6 = { class: "delayContainer" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "delay-tip" }
const _hoisted_9 = { style: {"font-size":"18px","color":"#f38350"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 测试视频 ")
const _hoisted_11 = {
  key: 0,
  class: "delay-video"
}
const _hoisted_12 = { class: "enable-switch" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "enable-switch-text" }, "启用学习平板控制", -1)
const _hoisted_14 = ["onClick"]
_popScopeId()

import store, { MutationNames } from "@/store/index";
import { VideoPlay } from "@element-plus/icons-vue";
import logger from "@evideo/logger";
import { ElMessage } from "element-plus";
import { onMounted, ref, computed } from "vue";


export default _defineComponent({
  emits: ["btnOpenDialog"],
  setup(__props, { emit }) {

const folderPathTxt = ref("");
const delayTime = ref(0);
const container = ref(null);
const padControl = ref<boolean>(false);



const btnOpenDialog = () => {
  emit("btnOpenDialog");
};

// 1.设置保存本地文件路径
const checkOpenDialog = () => {
  const { ipcRenderer } = window.require("electron");
  logger.info("向electron发送信息文件存储路径和声音延迟");
  ipcRenderer.sendToHost("openSetDirDiaLog", {
    type: "icePoint",
  });
};

// 3.就是一个弹窗
const handleGetFolderPath = async (event: any, message: any) => {
  folderPathTxt.value = message.folderPath;
  if (!message.FsAccessState) {
    ElMessage({
      offset: 200,
      message: "该路径无读写权限，请重新选择",
      center: true,
    });
  }
};

// 2.在 Electron 的渲染进程
if (window.require) {
  const { ipcRenderer } = window.require("electron");
  ipcRenderer.on("folderPath", handleGetFolderPath);
}

const activeIndex = ref(0);
const sliding = ref(false);

const activeIndexValue = computed(() => {
  if (activeIndex.value === 4) {
    return 0;
  } else {
    return activeIndex.value * 50 - 200;
  }
});
const increaseIndex = () => {
  if (activeIndex.value < 14 && activeIndex.value >= 0) {
    activeIndex.value++;
  }
};

const decreaseIndex = () => {
  if (activeIndex.value > 0 && activeIndex.value <= 14) {
    activeIndex.value--;
  }
};
const startSlide = (e: MouseEvent) => {
  e.preventDefault();
  sliding.value = true;
};

const slide = (e: MouseEvent) => {
  if (sliding.value) {
    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percent = x / rect.width;
    activeIndex.value = Math.max(0, Math.min(10, Math.round(percent * 10)));
  }
};

const stopSlide = () => {
  sliding.value = false;
};

const setActiveIndex = (index: number) => {
  activeIndex.value = index;
};

const confirmSetting = () => {
  delayVideoShow.value = false;
  let changePath = false;
  let changeVoice = false;
  let changeDeviceControl = false;
  delayTime.value = activeIndexValue.value;

  if (
    originDelayTime == delayTime.value &&
    originalFolderPath == folderPathTxt.value &&
    originEnabledDeviceControl == padControl.value
  ) {
    // 关闭弹窗
    btnOpenDialog();
    return;
  }
  if (
    originDelayTime !== delayTime.value &&
    originalFolderPath !== folderPathTxt.value
  ) {
    console.log("都改变");
    changePath = true;
    changeVoice = true;
  } else if (
    originDelayTime == delayTime.value &&
    originalFolderPath !== folderPathTxt.value
  ) {
    console.log("只改变路径");
    changePath = true;
    changeVoice = false;
  } else if (
    originDelayTime !== delayTime.value &&
    originalFolderPath == folderPathTxt.value
  ) {
    console.log("只改变声音");

    changePath = false;
    changeVoice = true;
  }
  if (padControl.value !== originEnabledDeviceControl) {
    changeDeviceControl = true;
  } else {
    changeDeviceControl = false;
  }

  store.commit(MutationNames.CHANGE_VOICEDELAYTIME, delayTime);
  if (!window || !window.require) {
    return;
  }
  const { ipcRenderer } = window.require("electron");
  logger.info("向electron发送确认设置");
  ipcRenderer.sendToHost("confirmSetting", {
    folderPath: folderPathTxt.value,
    delayTime: delayTime.value,
    enabledDeviceControl: padControl.value,
    changePath: changePath,
    changeVoice: changeVoice,
    changeDeviceControl: changeDeviceControl,
  });
  console.log("confirmSetting");
};
let originDelayTime: number;
let originalFolderPath: string;
let originEnabledDeviceControl: boolean;

const delayVideo = ref();
const delayVideoShow = ref(false);

onMounted(() => {
  if (!window || !window.require) {
    return;
  }
  const { ipcRenderer } = window.require("electron");
  ipcRenderer.on("responseFolderPathAndDelay", (event: any, res: any) => {
    console.log("responseFolderPathAndDelay", res);
    folderPathTxt.value = res.folderPath;
    originalFolderPath = res.folderPath;
    if (res.delayTime == -50) {
      activeIndex.value = 3;
    } else {
      activeIndex.value = res.delayTime / 50 + 4;
    }
    originDelayTime = res.delayTime;
    originEnabledDeviceControl = res.enabledDeviceControl;
    padControl.value = res.enabledDeviceControl;
    // 默认路径，没有设置新的路径
    if (res.isSetted === false) {
      folderPathTxt.value = "";
      // 将用于判断是否有更改路径得值设置为空，不触发更新
      originalFolderPath = "";
    }
  });
  ipcRenderer.sendToHost("requestFolderPathAndDelay");
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (btnOpenDialog())),
      class: "cancelButton"
    }, "×"),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_input, {
        class: "dvIcePointInp",
        modelValue: folderPathTxt.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (folderPathTxt.value = $event)),
        clearable: ""
      }, {
        append: _withCtx(() => [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (checkOpenDialog())),
            class: "changeFolder"
          }, "更改")
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "decreaseButton",
        onClick: decreaseIndex
      }, "<"),
      _createElementVNode("div", {
        class: "slider-container",
        ref: container,
        onMousemove: slide,
        onMouseup: stopSlide,
        onMouseleave: stopSlide
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (val, index) => {
          return _createElementVNode("div", {
            key: index,
            class: _normalizeClass(['bar', { active: index === activeIndex.value }]),
            onClick: ($event: any) => (setActiveIndex(index))
          }, null, 10, _hoisted_7)
        }), 64)),
        _createElementVNode("div", {
          class: "slider",
          style: _normalizeStyle({ left: `${activeIndex.value * (100 / 14)}%` }),
          onMousedown: startSlide
        }, null, 36)
      ], 544),
      _createElementVNode("div", {
        class: "increaseButton",
        onClick: increaseIndex
      }, ">")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, " 声音延迟输出" + _toDisplayString(_unref(activeIndexValue)) + "毫秒 ", 1),
      _createElementVNode("div", {
        style: {"font-size":"18px","color":"#78543a","align-items":"center","display":"flex","cursor":"pointer"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => (delayVideoShow.value = !delayVideoShow.value))
      }, [
        _createVNode(_component_el_icon, {
          size: 18,
          color: "#78543a"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VideoPlay))
          ]),
          _: 1
        }),
        _hoisted_10
      ])
    ]),
    (delayVideoShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "delay-video-mask",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (delayVideoShow.value = !delayVideoShow.value), ["stop"]))
          }),
          _createElementVNode("video", {
            ref: delayVideo,
            autoplay: "",
            loop: "",
            controls: "",
            controlslist: " nodownload noremoteplayback noplaybackrate",
            disablePictureInPicture: "",
            src: "https://public.ecoach.evideo.tech/public-%20resource/%E9%9F%B3%E7%94%BB%E5%90%8C%E6%AD%A5%E6%B5%8B%E8%AF%95.mp4",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, null, 512),
          _createElementVNode("div", {
            class: "delay-video-close",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (delayVideoShow.value = !delayVideoShow.value), ["stop"]))
          }, " X ")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", null, [
        _createVNode(_component_el_switch, {
          size: "large",
          modelValue: padControl.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (padControl.value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("button", {
      class: "confirmButton",
      onClick: _withModifiers(confirmSetting, ["stop"])
    }, "确认", 8, _hoisted_14)
  ]))
}
}

})